module.exports = __webpack_public_path__ + "static/media/GrungeCart1.3ca14d6d.jpg";